// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_documentation_documentation_module_ts":"08d77a74597a07d9","src_app_pages_page-notfound_page-notfound_module_ts":"cc18ebfeaf98bbec"}[chunkId] + ".js";
};